import { useParams } from "@tanstack/react-router";
import { useMemo } from "react";
import { createTradeMarketIdentity } from "../lib/hyperliquid";

export function useTradeSymbol() {
	const { symbol } = useParams({ from: "/trade/$symbol" });

	return useMemo(() => createTradeMarketIdentity(symbol), [symbol]);
}
